<template>
  <div class="wireless-box-view">
    <template v-if="!empty">
      <status-bar v-bind="status"></status-bar>
      <sensorList :list="seneorList" />
    </template>

    <template v-else>
      <div class="hint">{{ $t('数据加载中') }}</div>
    </template>
  </div>
</template>

<script>
let pmNameObj = {
  pm1: 'PM1.0 浓度',
  pm25: ' PM2.5',
  pm10: 'PM10',
  pmLevel: 'pm等级',
  pm1Atm: 'PM1.0 浓度 ',
  pm25Atm: ' PM2.5 浓度',
  pm10Atm: 'PM10 浓度 ',
  parCount1: '0.3以上颗粒数',
  parCount2: '0.5以上颗粒数',
  parCount3: '1.0以上颗粒数',
  parCount4: '2.5以上颗粒数',
  parCount5: '5.0以上颗粒数',
  parCount6: '10以上颗粒数',
  pmFault: '颗粒传感器故障'
};

import { isEmpty } from '@/utils/is';
import { closeWindowListener } from '@/utils/socket';
import { getSensorsGradeServer, getWirelessBoxListServer } from '@/api/devices';
import { mapActions } from 'vuex';

import StatusBar from './components/status-bar.vue';
import sensorList from '@/components/sensorList/index.vue';

export default {
  name: 'wireless-box',
  components: {
    sensorList,
    StatusBar
  },
  sockets: {
    '/socket/detail'(res) {
      this.setData(res);
    }
  },
  computed: {
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    },

    deviceType() {
      return this.$attrs.deviceType || this.$route.params.deviceType;
    }
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      seneorList: [], // 实时数据
      status: {
        alarmStatus: 0,
        runState: 0,
        humidity: 0,
        temp: 0
      },
      empty: false
    };
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    initData() {
      this.RG04Obj = {};
      this.RG04Data = [];
      this.GM606Obj = {};
      this.GM606Data = [];
      this.PMS6003Data = [];
      this.NRHM01Obj = {};
      this.NRHM01Data = [];

      this.realData = [];
    },

    setData(res) {
      try {
        this.empty = false;
        let { sn, deviceType, mods, beginTime } = res;

        if (mods.hasOwnProperty('weatherMod')) {
          this.status.humidity = mods.weatherMod.humidity;
          this.status.temp = mods.weatherMod.temp;
        }

        this.upDronePositionFlag = false;

        setTimeout(() => {
          this.upDronePositionFlag = true;
        }, 100);

        switch (deviceType) {
          case 'GM606':
            this.upGM606DataHandler(sn, mods.gm606Mod, beginTime, deviceType);
            break;
          case 'RG04':
            this.upRG04ModHandler(sn, mods.nuclearMod, beginTime, deviceType);
            break;
          case 'PMS6003':
            this.upPMS6003ModHandler(sn, mods.smokeMod, beginTime, deviceType);
            break;
          case 'NRH-M01':
            this.upNRHM01ModHandler(sn, mods.nrhM01Mod, beginTime, deviceType);
            break;
          default:
            break;
        }
        setTimeout(() => {
          this.packageSensorViewDataHandler();
          this.initMod = true;
        }, 100);
      } catch (err) {
        this.empty = true;
        console.error('[WIRELESSBOX][MONITRO][update error]', err);
      }
    },
    upGM606DataHandler(sn, val, time, deviceType) {
      let newGM606Data = [];
      this.GM606Data = [];
      val.sensors.forEach(item => {
        item.beginTime = time;
        item.deviceType = deviceType;
        item.sn = sn;
      });
      this.GM606Obj[sn] = val.sensors;
      Object.keys(this.GM606Obj).forEach(key => {
        newGM606Data = [...newGM606Data, ...this.GM606Obj[key]];
      });
      this.GM606Data = newGM606Data;
    },

    upRG04ModHandler(sn, val, beginTime, deviceType) {
      //   state 0 正常 1预警  2报警 3恢复
      let obj = {
        beginTime,
        deviceType,
        value: val.radDose,
        name: '剂量率',
        unitName: 'μSv/h',
        alarmState: val.state
      };

      if (val.state == 3) {
        obj.alarmState = 0;
      }
      val = { ...obj, ...val };

      let NRHM01Data = [];
      this.RG04Obj[sn] = [val];
      Object.keys(this.RG04Obj).forEach(key => {
        NRHM01Data = [...NRHM01Data, ...this.RG04Obj[key]];
      });
      this.RG04Data = NRHM01Data;
    },
    upPMS6003ModHandler(sn, val, beginTime, deviceType) {
      let newPMS6003Data = [];
      let showPmDto = ['pm25', 'pm10'];
      showPmDto.forEach(key => {
        let obj = {
          name: key,
          showName: Object.keys(pmNameObj).includes(key) ? pmNameObj[key] : key,
          value: val.pmDto[key],
          deviceType,
          beginTime,
          alarmState: 0,
          unitName: 'µg/m³'
        };
        newPMS6003Data.push(obj);
      });
      this.PMS6003Data = newPMS6003Data;
    },
    upNRHM01ModHandler(sn, val, beginTime, deviceType) {
      this.status.alarmStatus = val.state;
      this.status.runState = val.runstate;
      let obj = {
        beginTime,
        deviceType: deviceType,
        value: val.radonConcentration,
        name: '氡气/Rn',
        unitName: 'Bq/m³',
        alarmState: val.state
      };
      val = { ...val, ...obj };

      if (val.state == 3) {
        obj.alarmState = 0;
      }

      let NRHM01Data = [];
      this.NRHM01Obj[sn] = [val];
      Object.keys(this.NRHM01Obj).forEach(key => {
        NRHM01Data = [...NRHM01Data, ...this.NRHM01Obj[key]];
      });
      this.NRHM01Data = NRHM01Data;
    },

    packageSensorViewDataHandler() {
      this.seneorList = [
        ...this.RG04Data,
        ...this.GM606Data,
        ...this.PMS6003Data,
        ...this.NRHM01Data
      ];
      this.seneorList.forEach((item, index) => {
        let { deviceType, name, value } = item;
        if (!this.seneorGrade.hasOwnProperty(deviceType)) return;

        this.seneorGrade[deviceType].forEach(sitem => {
          if (sitem.sensorTypeCode.includes(name)) {
            sitem.deviceSensorTypeGradeDtos.forEach(sensorItem => {
              if (
                value >= Number(sensorItem.gradeLowValue) &&
                value <= Number(sensorItem.gradeHighValue)
              ) {
                this.seneorList[index].color = sensorItem.gradeMark;
              }
            });
          }
        });
      });
    },
    loadWirelessBoxHandler() {
      getWirelessBoxListServer(this.deviceType).then(res => {
        if (isEmpty(res.data)) return;

        const currentBox = res.data.filter(item => {
          return item.sn === this.sn;
        });

        if (isEmpty(currentBox)) return;
        currentBox[0].wirelessBoxConfDtoList.forEach(item => {
          this.snList.push(item.sn);
        });
        if (isEmpty(this.snList)) return;

        this.subDeviceDetail({ sn: this.snList });
      });
    },
    loadSensorGradeHandler() {
      let sensorType = ['GM606', 'RG04', 'PMS6003', 'NRH-M01'];
      getSensorsGradeServer(sensorType).then(res => {
        this.seneorGrade = res.data;
      });
    },
    unsubscribe() {
      this.unsubDeviceDetail({ sn: this.snList });
      this.sockets.unsubscribe('/socket/param');
    }
  },
  created() {
    this.removeListener = closeWindowListener(() => this.unsubscribe());
    this.snList = [];
    this.loadWirelessBoxHandler();
    this.loadSensorGradeHandler();
    this.initData();
  },

  beforeDestroy() {
    if (!this.snList.length) return;
    this.unsubDeviceDetail({ sn: this.snList });
  }
};
</script>

<style scoped lang="scss">
.wireless-box-view {
  width: 100%;
  height: 100%;

  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
